import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  HStack,
  Icon,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Text,
  VStack,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import { useState } from 'react';
import {
  MdArrowForward,
  MdCampaign,
  MdConstruction,
  MdEventAvailable,
  MdFavorite,
  MdGroups,
  MdNewspaper,
  MdPark,
  MdPlace,
  MdPublic,
} from 'react-icons/md';
import logo from 'assets/img/profile/logo.png';

const proyectos = [
  {
    titulo: 'Mejoramiento de vialidades',
    descripcion: 'Programa de rehabilitacion de calles, guarniciones y banquetas en comunidades prioritarias.',
    icon: MdConstruction,
    color: '#5b182b',
  },
  {
    titulo: 'Espacios publicos dignos',
    descripcion: 'Mantenimiento de parques, areas verdes y puntos de convivencia familiar.',
    icon: MdPark,
    color: '#8b5e34',
  },
  {
    titulo: 'Atencion ciudadana cercana',
    descripcion: 'Jornadas de orientacion, recepcion de solicitudes y seguimiento a reportes vecinales.',
    icon: MdGroups,
    color: '#0f766e',
  },
];

const noticias = [
  {
    titulo: 'Jornada comunitaria',
    resumen: 'El Ayuntamiento invita a participar en actividades de limpieza y mejora urbana.',
    categoria: 'Comunidad',
  },
  {
    titulo: 'Atencion en ventanilla',
    resumen: 'Consulta horarios de atencion para tramites administrativos y servicios municipales.',
    categoria: 'Servicios',
  },
  {
    titulo: 'Obras en seguimiento',
    resumen: 'Se mantiene la supervision de trabajos de infraestructura en distintas zonas del municipio.',
    categoria: 'Obras',
  },
];

const anuncios = [
  'Consulta los requisitos antes de iniciar cualquier tramite municipal.',
  'Los documentos oficiales deben validarse unicamente en canales autorizados.',
  'Mantente atento a comunicados y jornadas de atencion ciudadana.',
];

const servicios = [
  { label: 'Tramites municipales', value: 'Orientacion y seguimiento', icon: MdNewspaper },
  { label: 'Obras Publicas', value: 'Licencias, permisos y constancias', icon: MdConstruction },
  { label: 'Eventos y jornadas', value: 'Convocatorias ciudadanas', icon: MdEventAvailable },
  { label: 'Participacion social', value: 'Reportes y solicitudes', icon: MdFavorite },
];

export default function Inicio() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selected, setSelected] = useState<{ titulo: string; descripcion: string } | null>(null);
  const cardBg = useColorModeValue('rgba(255,255,255,0.88)', 'rgba(30,21,25,0.92)');
  const softBg = useColorModeValue('#fbfaf7', 'rgba(255,255,255,0.06)');
  const softAccentBg = useColorModeValue('#f2e8dd', 'rgba(255,255,255,0.10)');
  const warmBg = useColorModeValue('#f4eadf', 'rgba(161,38,61,0.18)');
  const titleColor = useColorModeValue('#2b0913', 'white');
  const textColor = useColorModeValue('#74635d', 'whiteAlpha.700');
  const borderColor = useColorModeValue('rgba(104,26,45,0.10)', 'rgba(255,255,255,0.10)');

  const openProject = (project: { titulo: string; descripcion: string }) => {
    setSelected(project);
    onOpen();
  };

  return (
    <Box minH="100vh" pt={{ base: '92px', md: '78px' }} pb={8} position="relative" overflow="hidden">
      <Box
        position="absolute"
        inset={0}
        pointerEvents="none"
        bg="radial-gradient(circle at 12% 4%, rgba(161,38,61,0.10), transparent 28%), radial-gradient(circle at 92% 18%, rgba(184,132,77,0.10), transparent 26%)"
      />

      <VStack spacing={6} align="stretch" position="relative">
        <Box
          borderRadius="32px"
          overflow="hidden"
          bg="linear-gradient(135deg, #2b0913 0%, #681a2d 54%, #9b2b40 100%)"
          color="white"
          boxShadow="0 24px 60px rgba(67, 28, 27, 0.20)"
          position="relative"
        >
          <Box position="absolute" right="-90px" top="-100px" w="330px" h="330px" borderRadius="full" bg="rgba(184,132,77,0.18)" />
          <Box position="absolute" left="42%" bottom="-120px" w="260px" h="260px" borderRadius="full" bg="rgba(255,255,255,0.08)" />

          <Grid templateColumns={{ base: '1fr', xl: '1.08fr .92fr' }} gap={7} p={{ base: 6, md: 8, xl: 10 }} position="relative">
            <Box>
              <HStack spacing={4} mb={7}>
                <Flex w="74px" h="74px" align="center" justify="center" borderRadius="24px" bg="white" boxShadow="0 16px 36px rgba(0,0,0,0.22)">
                  <Image src={logo} alt="Totolac" maxW="60px" maxH="60px" objectFit="contain" />
                </Flex>
                <Box>
                  <Badge bg="rgba(255,255,255,0.16)" color="#f2d6b5" border="1px solid rgba(242,214,181,0.24)" borderRadius="full" px={3} py={1}>
                    Informacion publica
                  </Badge>
                  <Text mt={2} fontSize="sm" color="whiteAlpha.750">H. Ayuntamiento de Totolac</Text>
                </Box>
              </HStack>

              <Text fontSize={{ base: '32px', md: '46px', xl: '54px' }} fontWeight="950" lineHeight="0.98" letterSpacing="-1.8px">
                Portal informativo municipal.
              </Text>
              <Text mt={4} maxW="720px" fontSize={{ base: 'md', md: 'lg' }} color="whiteAlpha.800" lineHeight="1.7">
                Espacio para publicar avisos, proyectos, noticias, jornadas y contenido institucional que el Ayuntamiento requiera comunicar.
              </Text>

              <HStack mt={7} spacing={3} flexWrap="wrap">
                <Button
                  leftIcon={<MdCampaign />}
                  bg="#f7f4ee"
                  color="#681a2d"
                  borderRadius="16px"
                  _hover={{ bg: 'white', transform: 'translateY(-2px)' }}
                  onClick={() => document.getElementById('anuncios-publicos')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Ver anuncios
                </Button>
                <Button
                  rightIcon={<MdArrowForward />}
                  variant="outline"
                  borderColor="rgba(255,255,255,0.36)"
                  color="white"
                  borderRadius="16px"
                  _hover={{ bg: 'whiteAlpha.200' }}
                  onClick={() => document.getElementById('proyectos-publicos')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Proyectos destacados
                </Button>
              </HStack>
            </Box>

            <Box
              borderRadius="28px"
              overflow="hidden"
              bg="rgba(255,255,255,0.12)"
              border="1px solid rgba(255,255,255,0.16)"
              boxShadow="0 18px 40px rgba(0,0,0,0.16)"
              minH={{ base: '240px', md: '320px' }}
              position="relative"
            >
              <Box
                as="iframe"
                src="https://www.youtube.com/embed/rZpSnmms0LM?autoplay=1&mute=1&loop=1&playlist=rZpSnmms0LM"
                title="Video institucional de Totolac"
                allow="autoplay; encrypted-media"
                allowFullScreen
                width="100%"
                height="100%"
                position="absolute"
                inset={0}
                border="none"
              />
              <Box pt="56.25%" />
            </Box>
          </Grid>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} spacing={5}>
          {servicios.map((item) => (
            <Box key={item.label} p={5} bg={cardBg} border="1px solid" borderColor={borderColor} borderRadius="26px" boxShadow="0 16px 38px rgba(68, 42, 31, 0.07)">
              <Flex w="48px" h="48px" align="center" justify="center" borderRadius="18px" bg={softAccentBg} mb={5}>
                <Icon as={item.icon} boxSize={6} color="#681a2d" />
              </Flex>
              <Text fontWeight="950" fontSize="lg" color={titleColor}>{item.label}</Text>
              <Text mt={2} fontSize="sm" color={textColor} lineHeight="1.55">{item.value}</Text>
            </Box>
          ))}
        </SimpleGrid>

        <Box id="proyectos-publicos" bg={cardBg} border="1px solid" borderColor={borderColor} borderRadius="28px" p={{ base: 5, md: 6 }} boxShadow="0 16px 38px rgba(68, 42, 31, 0.07)">
          <Flex justify="space-between" align={{ base: 'flex-start', md: 'center' }} gap={4} direction={{ base: 'column', md: 'row' }} mb={5}>
            <Box>
              <Text fontSize="xs" letterSpacing="0.14em" textTransform="uppercase" color="#5b182b" fontWeight="900">
                Contenido editable
              </Text>
              <Text fontSize="2xl" fontWeight="950" color={titleColor}>Proyectos y propuestas</Text>
            </Box>
            <Badge bg="#f0e7dc" color="#681a2d" borderRadius="full" px={3} py={1}>Informacion dummie</Badge>
          </Flex>

          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={5}>
            {proyectos.map((project) => (
              <Box
                key={project.titulo}
                p={5}
                borderRadius="24px"
                bg={softBg}
                border="1px solid"
                borderColor={borderColor}
                transition="all .2s ease"
                _hover={{ transform: 'translateY(-4px)', boxShadow: '0 18px 34px rgba(68,42,31,.10)' }}
              >
                <Flex w="46px" h="46px" align="center" justify="center" borderRadius="17px" bg={`${project.color}17`} mb={4}>
                  <Icon as={project.icon} color={project.color} boxSize={6} />
                </Flex>
                <Text fontWeight="950" color={titleColor} fontSize="lg">{project.titulo}</Text>
                <Text mt={2} color={textColor} fontSize="sm" lineHeight="1.6">{project.descripcion}</Text>
                <Button mt={5} size="sm" bg="#681a2d" color="white" borderRadius="14px" _hover={{ bg: '#5b182b' }} onClick={() => openProject(project)}>
                  Ver mas
                </Button>
              </Box>
            ))}
          </SimpleGrid>
        </Box>

        <Grid templateColumns={{ base: '1fr', xl: '1.1fr .9fr' }} gap={5}>
          <Box bg={cardBg} border="1px solid" borderColor={borderColor} borderRadius="28px" p={{ base: 5, md: 6 }} boxShadow="0 16px 38px rgba(68, 42, 31, 0.07)">
            <HStack mb={5} spacing={3}>
              <Flex w="44px" h="44px" align="center" justify="center" borderRadius="16px" bg="#681a2d">
                <Icon as={MdNewspaper} color="white" boxSize={5} />
              </Flex>
              <Box>
                <Text fontSize="xs" letterSpacing="0.14em" textTransform="uppercase" color="#5b182b" fontWeight="900">
                  Noticias
                </Text>
                <Text fontSize="xl" fontWeight="950" color={titleColor}>Comunicados recientes</Text>
              </Box>
            </HStack>

            <VStack align="stretch" spacing={3}>
              {noticias.map((notice) => (
                <Flex key={notice.titulo} gap={4} p={4} borderRadius="20px" bg={softBg} border="1px solid" borderColor={borderColor}>
                  <Flex minW="42px" h="42px" align="center" justify="center" borderRadius="15px" bg={softAccentBg}>
                    <Icon as={MdPublic} color="#681a2d" boxSize={5} />
                  </Flex>
                  <Box>
                    <Badge bg="#f0e7dc" color="#681a2d" borderRadius="full" mb={2}>{notice.categoria}</Badge>
                    <Text fontWeight="900" color={titleColor}>{notice.titulo}</Text>
                    <Text fontSize="sm" color={textColor} lineHeight="1.55">{notice.resumen}</Text>
                  </Box>
                </Flex>
              ))}
            </VStack>
          </Box>

          <Box id="anuncios-publicos" bg={cardBg} border="1px solid" borderColor={borderColor} borderRadius="28px" p={{ base: 5, md: 6 }} boxShadow="0 16px 38px rgba(68, 42, 31, 0.07)">
            <HStack mb={5} spacing={3}>
              <Flex w="44px" h="44px" align="center" justify="center" borderRadius="16px" bg="#5b182b">
                <Icon as={MdCampaign} color="white" boxSize={5} />
              </Flex>
              <Box>
                <Text fontSize="xs" letterSpacing="0.14em" textTransform="uppercase" color="#5b182b" fontWeight="900">
                  Anuncios oficiales
                </Text>
                <Text fontSize="xl" fontWeight="950" color={titleColor}>Avisos para la ciudadania</Text>
              </Box>
            </HStack>

            <VStack align="stretch" spacing={3}>
              {anuncios.map((notice, index) => (
                <Flex key={notice} gap={3} p={4} borderRadius="20px" bg={index === 0 ? warmBg : softBg} border="1px solid" borderColor={borderColor}>
                  <Flex minW="28px" h="28px" align="center" justify="center" borderRadius="full" bg="#5b182b" color="white" fontWeight="900" fontSize="sm">
                    {index + 1}
                  </Flex>
                  <Text fontSize="sm" color={textColor} lineHeight="1.55">{notice}</Text>
                </Flex>
              ))}
              <HStack pt={2} color={textColor} fontSize="sm">
                <Icon as={MdPlace} color="#5b182b" />
                <Text>Totolac, Tlaxcala</Text>
              </HStack>
            </VStack>
          </Box>
        </Grid>
      </VStack>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay bg="blackAlpha.500" />
        <ModalContent borderRadius="24px" overflow="hidden">
          <ModalHeader bg="#681a2d" color="white">{selected?.titulo}</ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody p={6}>
            <Text color={textColor} lineHeight="1.7">
              {selected?.descripcion} Este espacio puede reemplazarse con informacion oficial, fechas, responsables, avances o comunicados definidos por el Ayuntamiento.
            </Text>
            <Button mt={5} w="100%" bg="#5b182b" color="white" borderRadius="16px" _hover={{ bg: '#681a2d' }} onClick={onClose}>
              Cerrar
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}
